import apiClient from './api';

export const getAllNotifs = () => apiClient.get("/notification/get-all");

export const deleteNotif = (notif_id) => apiClient.post("/notification/delete", { notif_id });

export const markAsRead = (user_id, notif_id) => apiClient.post("/notification/mark-as-read", { user_id, notif_id });